import * as yup from 'yup'

export class PulledClusterPhotoDto {
  documentGuid?: string = undefined
  displayFileName?: string = undefined
    pulledClusterPhotoFile?: File = undefined
  note?: string = undefined
}

export const pulledClusterPhotoValidationSchema = yup.object({
  pulledClusterPhotoFile: yup.mixed().required('Pulled Cluster Photo is required.'),
  note: yup.string().max(250, 'Notes cannot be more than 250 characters').nullable()
})
